export default __webpack_public_path__ + "static/media/product-13.fcd92789.webp";